import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from "vue";
import BaseInput from "./_base.vue";
import { useField } from "vee-validate";

interface Props {
    name: string;
    label: string;
    value?: string;
    onValue: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    name: { type: String, required: true, default: undefined },
    label: { type: String, required: true, default: undefined },
    value: { type: String, required: false, default: undefined },
    onValue: { type: String, required: true, default: "aan" }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { name: string, label: string, value: string, onValue: string }



const { value: initialValue, errorMessage, handleBlur, handleChange, meta, checked } = useField(props.name, undefined, { type: "radio" });

const uid = getCurrentInstance()?.uid;

const handleChangeEvent = (e: any) => {
    if (e.target.value === "on") {
        handleChange(props.onValue);
    }
};

const __returned__ = { props, initialValue, errorMessage, handleBlur, handleChange, meta, checked, uid, handleChangeEvent, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})